import { TimelineMax, Power3 } from 'gsap/TweenMax';
import { isTouchDevice } from '@/scripts/utils';
import store from '@/store';

export const navEnter = (nav, dots, caption, progressBar, type, callback) => {
  const left = window.innerWidth < 1024 ? '50vw' : '37.5vw';
  const width = window.innerWidth < 1024 ? '73.3vw' : caption.getBoundingClientRect().width;
  const xPercent = window.innerWidth < 1024 ? '-50%' : 0;
  const tl = new TimelineMax({
    onComplete: callback,
  });

  tl.addLabel('start')
    .to(nav, 0.5, {
      left,
      autoAlpha: 1,
    }, 'start')
    .to(dots, 0.5, {
      autoAlpha: 0,
    }, 'start')
    .to('.app__slider-year', 0.3, { autoAlpha: 0 }, 'start')
    .fromTo(caption, 0.3, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
    }, 'start+=0.5');

  if (type === 'default') {
    if (store.state.route.name === 'home') tl.to(progressBar, 0.5, { scaleX: 1 }, 'start');
    tl.to(nav, 0.5, { width, xPercent }, 'start');
  } else {
    if (store.state.route.name === 'home') tl.fromTo(progressBar, 1, { scaleX: 0 }, { scaleX: 1, ease: Power3.easeInOut }, 'start+=0.8');
    tl.set(nav, { width, xPercent }, 'start');
  }

  return tl;
};

export const navToScroll = (nav, dots, caption, callback) => {
  const width = window.innerWidth < 1024 ? '73.3vw' : '68.75vw';
  const left = '50vw';
  const xPercent = '-50%';
  const autoAlpha = isTouchDevice() ? 0 : 1;
  const autoAlpha1 = window.innerWidth < 1024 ? 1 : 0;
  const tl = new TimelineMax({
    onComplete: callback,
  });

  tl.addLabel('start')
    .to(nav, 0.5, {
      width,
      left,
      xPercent,
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 'start')
    .staggerTo(dots, 0.5, {
      autoAlpha,
      y: 0,
      ease: Power3.easeInOut,
    }, 0.05, 'start')
    .to(caption, 0.3, {
      autoAlpha: 0,
    }, 'start')
    .to('.app__slider-year', 0.5, {
      autoAlpha: autoAlpha1,
      ease: Power3.easeInOut,
    }, 'start');

  return tl;
};

export const navToPage = (nav, dots, caption, callback) => {
  const tl = new TimelineMax({
    onComplete: callback,
  });

  tl.addLabel('start')
    .to(nav, 0.4, {
      autoAlpha: 0,
    }, 'start+=0.3')
    .staggerTo(dots, 0.5, {
      autoAlpha: 0,
      y: 40,
    }, 0.05, 'start');

  return tl;
};

export const yearMenuIn = () => {
  const tl = new TimelineMax();

  tl.addLabel('start')
    .to('.app__year', 0.3, {
      y: -80,
      scaleY: 1.3,
      autoAlpha: 0,
    }, 'start')
    .set('.app__year', {
      top: 'unset',
      bottom: 80,
      left: '50%',
      xPercent: -50,
    })
    .to('.app__year', 0.3, {
      y: 0,
      scaleY: 1,
      autoAlpha: 1,
    });

  return tl;
};

export const yearMenuOut = () => {
  const tl = new TimelineMax();

  tl.addLabel('start')
    .to('.app__year', 0.3, {
      y: -80,
      scaleY: 1.3,
      autoAlpha: 0,
      transformOrigin: '50% 0%',
    }, 'start')
    .set('.app__year', {
      top: 45,
      bottom: 'unset',
      left: 150,
      xPercent: 0,
    })
    .to('.app__year', 0.3, {
      y: 0,
      scaleY: 1,
      transformOrigin: '50% 100%',
      autoAlpha: 1,
    });

  return tl;
};
